/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { actions } from "store/duck/bulkUpload/actions"
import { ACTION_TYPE } from "types/delv-platform-api/inventoryCategory"
import BulkUploadDrawer from "./bulkUploadDrawer/BulkUploadDrawer"
import BulkUploadActionsMenu from "./bulkUploadActions/BulkUploadActionsMenu"
import PastUploads from "./pastUploads/PastUploads"

import {
  DRAWER_STATES,
  BulkUploadContext,
  BULK_UPLOAD_TYPE,
} from "./BulkUploadContext"
import BulkUploadActionsInventory from "./bulkUploadActions/BulkUploadActionsInventory"

export const BulkUpload = ({
  bulkUploadType = BULK_UPLOAD_TYPE.INVENTORY,
}: {
  bulkUploadType?: BULK_UPLOAD_TYPE
}) => {
  const dispatch = useDispatch()
  const [actionType, setActionType] = useState(ACTION_TYPE.UPDATE)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [drawerState, setDrawerState] = useState(DRAWER_STATES.START)
  const [
    drawerStateTransitionDisabled,
    setDrawerStateTransitionDisabled,
  ] = useState(false)
  const [modalEditorVisible, setModalEditorVisible] = useState(false)

  useEffect(() => {
    dispatch(actions.resetInventoryCategory())
  }, [dispatch])

  return (
    <BulkUploadContext.Provider
      value={{
        actionType,
        drawerState,
        drawerVisible,
        modalEditorVisible,
        drawerStateTransitionDisabled,
        setActionType,
        setDrawerState,
        setDrawerVisible,
        setModalEditorVisible,
        setDrawerStateTransitionDisabled,
        bulkUploadType,
      }}
    >
      <div
        css={css`
          padding-top: 24px;
        `}
      >
        <div>
          {bulkUploadType === BULK_UPLOAD_TYPE.INVENTORY ? (
            <BulkUploadActionsInventory />
          ) : (
            <BulkUploadActionsMenu />
          )}
        </div>
        <div
          css={css`
            margin-top: 48px;
          `}
        >
          <PastUploads />
        </div>
        <BulkUploadDrawer />
      </div>
    </BulkUploadContext.Provider>
  )
}
